import React, { useCallback, useEffect, useState } from 'react';

// You might be asking yourself, why? Why would you do this?
// Aha! MVC batches updates which means we cannot control an input field with state stored in a controller. Input fields require synchronous updates.
// This component can be controlled by state from an MVC controller since, internally, it updates itself synchronously.
// The problem is supposed to be fixable once we upgrade to React 18 since we will no longer need to do manual batching in the Aha! MVC framework.
const withRef = React.forwardRef<
  HTMLInputElement,
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
>(function SemiControlledInput(props, ref) {
  const { value, onChange, ...otherProps } = props;
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const innerOnChange = useCallback(
    e => {
      setInputValue(e.target.value);
      onChange?.(e);
    },
    [onChange]
  );

  return (
    <input
      {...otherProps}
      value={inputValue}
      onChange={innerOnChange}
      ref={ref}
    />
  );
});

export default withRef;
